/**
 * "5 min ago", "yesterday": how long ago a server time (ISO 8601) was, in the user's
 * language, for lists that show recent activity. A text that is not a date is shown as it is.
 */
const STEPS: readonly (readonly [Intl.RelativeTimeFormatUnit, number])[] = [
  ["second", 60],
  ["minute", 60],
  ["hour", 24],
  ["day", 7],
  ["week", 4.35],
  ["month", 12],
  ["year", Number.POSITIVE_INFINITY],
];

export function formatTimeAgo(isoText: string, language: string | undefined, now: number = Date.now()): string {
  const time = Date.parse(isoText);
  if (Number.isNaN(time)) {
    return isoText;
  }
  let amount = (time - now) / 1000;
  const format = new Intl.RelativeTimeFormat(language, { numeric: "auto", style: "short" });
  for (const [unit, size] of STEPS) {
    if (Math.abs(amount) < size) {
      return format.format(Math.round(amount), unit);
    }
    amount /= size;
  }
  return format.format(Math.round(amount), "year");
}
